function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "notifications/badge/large/3-digits",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "New-Notification"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#F8C723",
  fillRule: "nonzero",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  fill: "#F8C723",
  fillRule: "nonzero",
  cx: 30,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F8C723",
  fillRule: "nonzero",
  x: 10.2,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("text", {
  id: "New",
  fontFamily: "NunitoSans-Bold, Nunito Sans",
  fontSize: 12,
  fontWeight: "bold",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 7.244,
  y: 13
}, "New"))));

function SvgIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notifications/badge/large/3-digits") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNew);
export default __webpack_public_path__ + "static/media/icon_new.8ea9c5d8.svg";
export { ForwardRef as ReactComponent };